import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { ProjectRoleAutoComplete } from "@components/role/role-autocomplete/project-role-autocomplete";
import { Button, Skeleton } from "@flat-ui";
import { useInviteMembersToProject } from "@hooks/projects/use-invite-members-to-project";
import { Box, Stack } from "@mui-wrapper";
import { fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";

/** Renders autocomplete and role selection to invite members to project in share dialog */
export function InviteMemberToProjectDialog(t0) {
  const $ = _c(21);
  const {
    project
  } = t0;
  const {
    isFetchingCompanyMembers
  } = useAppSelector(fetchingMembersFlagsSelector);
  let t1;
  if ($[0] !== project) {
    t1 = {
      project,
      location: "share-project-dialog"
    };
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    autocompleteOptions,
    selectedMembers,
    helperText,
    handleMemberSelect,
    onInputChange,
    isValidInput,
    selectedRole,
    setSelectedRole,
    canAssignProjectRoles,
    isLoading,
    shouldSendInviteDisable,
    handleConfirm
  } = useInviteMembersToProject(t1);
  if (isFetchingCompanyMembers) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Skeleton variant="rectangular" height="47px" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== autocompleteOptions || $[4] !== handleMemberSelect || $[5] !== helperText || $[6] !== isValidInput || $[7] !== onInputChange || $[8] !== selectedMembers) {
    t2 = <MembersAutocomplete isRequired={true} hasAutoFocus={true} label="Members" helperText={helperText} onInputChange={onInputChange} options={autocompleteOptions} selectedOptions={selectedMembers} handleMemberSelect={handleMemberSelect} isValid={isValidInput} />;
    $[3] = autocompleteOptions;
    $[4] = handleMemberSelect;
    $[5] = helperText;
    $[6] = isValidInput;
    $[7] = onInputChange;
    $[8] = selectedMembers;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== canAssignProjectRoles || $[11] !== handleConfirm || $[12] !== isLoading || $[13] !== selectedMembers.length || $[14] !== selectedRole || $[15] !== setSelectedRole || $[16] !== shouldSendInviteDisable) {
    t3 = selectedMembers.length > 0 && <>{canAssignProjectRoles && <Box sx={{
        mt: SPACE_ELEMENTS_OF_MODAL
      }}><ProjectRoleAutoComplete isRequired={true} selectedRole={selectedRole} onChange={role => setSelectedRole(role)} /></Box>}<Button variant="ghost" disabled={shouldSendInviteDisable} isLoading={isLoading} onClick={handleConfirm} sx={{
        mt: SPACE_ELEMENTS_OF_MODAL
      }}>Invite</Button></>;
    $[10] = canAssignProjectRoles;
    $[11] = handleConfirm;
    $[12] = isLoading;
    $[13] = selectedMembers.length;
    $[14] = selectedRole;
    $[15] = setSelectedRole;
    $[16] = shouldSendInviteDisable;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t2 || $[19] !== t3) {
    t4 = <Stack>{t2}{t3}</Stack>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}